import { JobRequestsDataState, JobRequestsState } from './types';

export const INITIAL_JOB_REQUESTS_DATA_STATE: JobRequestsDataState = {
  jobRequests: [],
  jobRequest: null,
};

export const INITIAL_JOB_REQUESTS_STATE: JobRequestsState = {
  ...INITIAL_JOB_REQUESTS_DATA_STATE,
  jobRequestsLoading: false,
  jobRequestsError: null,
  jobRequestsSuccess: null,
  jobRequestsTotalCount: 0,
  jobRequestLoading: false,
  jobRequestError: null,
  jobRequestSuccess: null,
};
